import {StickyNavigationMenuItemDefautBox} from "./sticky-navigation-menu-item.default.box";


export const StickyNavigationMenuItemBox = StickyNavigationMenuItemDefautBox;
